import { useLazyQuery as useApolloLazyQuery } from '@apollo/client'

export const useLazyQuery = (query, options = { fetchPolicy: 'cache-first' }) => {
  const [getData, data] = useApolloLazyQuery(query, options)

  const queryFn = options => getData(options)

  return [queryFn, data]
}
